module.exports = __webpack_public_path__ + "img/maurin.c41fb276.jpg";